import { c as _c } from "react/compiler-runtime";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";
import { twMerge } from "tailwind-merge";
import { InputError, InputLabel } from "@/components/global/form/inputs/";
import Icon from "@/components/icon";
import { FormFieldLayout } from "../layouts/form-field-layout";
interface FormDatePickerProps {
  name: string;
  label: string;
  required?: boolean;
  error?: string;
  isValid?: boolean;
  placeholder?: string;
  dataCy?: string;
  disabled?: boolean;
  value?: Dayjs | null;
  onChange?: (value: Dayjs | null) => void;
  minDate?: Dayjs;
  styles?: {
    wrapper?: {
      className?: string;
    };
    error?: {
      className?: string;
    };
    label?: {
      className?: string;
    };
    layout?: {
      className?: string;
    };
  };
}
export const FormDatePicker = t0 => {
  const $ = _c(47);
  const {
    name,
    label,
    required,
    error,
    isValid,
    placeholder,
    dataCy,
    disabled,
    value,
    onChange,
    minDate,
    styles
  } = t0;
  const t1 = styles?.layout?.className;
  const t2 = styles?.label;
  let t3;
  if ($[0] !== label || $[1] !== name || $[2] !== required || $[3] !== t2) {
    t3 = <InputLabel htmlFor={name} label={label} required={required} styles={t2} />;
    $[0] = label;
    $[1] = name;
    $[2] = required;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !!error;
  const t5 = placeholder || "S\xE9lectionner une date";
  let t6;
  if ($[5] !== dataCy) {
    t6 = {
      "data-cy": dataCy
    };
    $[5] = dataCy;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = error && "border-primary bg-danger3";
  const t8 = styles?.wrapper?.className;
  let t9;
  if ($[7] !== t7 || $[8] !== t8) {
    t9 = twMerge("w-full", t7, t8);
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#9b9b9b"
        },
        "&:hover fieldset": {
          borderColor: "#9b9b9b"
        },
        "&.Mui-focused fieldset": {
          borderColor: "#9b9b9b"
        }
      },
      "& .MuiInputBase-input::placeholder": {
        fontStyle: "italic"
      },
      "& .MuiInputBase-input:not(:placeholder-shown)": {
        fontStyle: "normal"
      }
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== required || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t9) {
    t11 = {
      fullWidth: true,
      required,
      error: t4,
      variant: "outlined",
      size: "medium",
      placeholder: t5,
      inputProps: t6,
      className: t9,
      sx: t10
    };
    $[11] = required;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [{
      name: "offset",
      options: {
        offset: [0, 10]
      }
    }];
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      placement: "bottom-start",
      disablePortal: true,
      modifiers: t12,
      sx: {
        zIndex: 9999,
        "& .MuiPaper-root": {
          zIndex: 9999
        }
      },
      onClick: _temp
    };
    t14 = {
      sx: {
        zIndex: 9999
      },
      onClick: _temp2
    };
    $[18] = t13;
    $[19] = t14;
  } else {
    t13 = $[18];
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t11) {
    t15 = {
      textField: t11,
      popper: t13,
      desktopPaper: t14
    };
    $[20] = t11;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== disabled || $[23] !== minDate || $[24] !== onChange || $[25] !== t15 || $[26] !== value) {
    t16 = <DatePicker value={value} onChange={onChange} format="DD/MM/YYYY" minDate={minDate} disabled={disabled} slotProps={t15} />;
    $[22] = disabled;
    $[23] = minDate;
    $[24] = onChange;
    $[25] = t15;
    $[26] = value;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== error) {
    t17 = error && <Icon icon="cross" size={25} className="text-primary" />;
    $[28] = error;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== error || $[31] !== isValid) {
    t18 = isValid && !error && <Icon icon="check-simple" size={25} className="text-success2" />;
    $[30] = error;
    $[31] = isValid;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t17 || $[34] !== t18) {
    t19 = <div className="flex items-center gap-2 absolute right-10 top-3">{t17}{t18}</div>;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t16 || $[37] !== t19) {
    t20 = <div className="relative w-full">{t16}{t19}</div>;
    $[36] = t16;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== error || $[40] !== styles?.error) {
    t21 = error && <InputError error={error} styles={styles?.error} />;
    $[39] = error;
    $[40] = styles?.error;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t1 || $[43] !== t20 || $[44] !== t21 || $[45] !== t3) {
    t22 = <FormFieldLayout className={t1}>{t3}{t20}{t21}</FormFieldLayout>;
    $[42] = t1;
    $[43] = t20;
    $[44] = t21;
    $[45] = t3;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
};
function _temp(e) {
  e.stopPropagation();
  e.preventDefault();
}
function _temp2(e_0) {
  e_0.stopPropagation();
}